import axios from '../../axios/axios';
import ipAddress from '../../axios/ipAddress' //域名
import QS from 'qs'; //序列化

/**
 * 客户相关接口
 */
const customer = {

      /**
       * 管理系统
       */
      customerList(page){
         return axios.post(ipAddress.qi+'/admin/a1/customer/page',page,true)
      },
      /**
       * 筛选类型
       */
      getVipTypeAndExceptionStatus(){
         return axios.post(ipAddress.qi+'/admin/a1/commons/getVipTypeAndExceptionStatus',null,false)
      },
      //异常列表
      getExceptionList(id){
         return axios.post(ipAddress.qi+'/admin/s1/customer-exception/getCustomerException',QS.stringify({
            id:id
        }),false)
      },
      //添加异常
      addException(form){
         return axios.post(ipAddress.qi+'/admin/s1/customer-exception/save',form,true)
      },
      //编辑异常
      updateException(form){
         return axios.post(ipAddress.qi+'/admin/s1/customer-exception/update',form,true)
      },

      //客户异常记录列表
      customException(id){
         return axios.post(ipAddress.qi+'/admin/s1/customer-exception/list',QS.stringify({
            id:id
        }),false)
      },

      //通过异常
      upStatus(form){
         return axios.post(ipAddress.qi+'/admin/s1/customer-exception/upStatus',form,true)
      },

}
export default customer;


// WEBPACK FOOTER //
// ./src/js/customer/customer.js